var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kk-zuruck d-flex d-md-none align-center justify-center clickable",class:{
    'kk-zuruck--hidden': !_vm.visible,
  },on:{"click":_vm.onZuruck}},[_c('v-icon',{attrs:{"color":"corporateGrey"}},[_vm._v("mdi-chevron-up")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }